<template>

    <div v-if="inputGroupAppend || inputGroupPrepend" class="input-group">
        <div v-if="inputGroupPrepend" class="input-group-prepend">
            <span class="input-group-text">{{ inputGroupPrepend }}</span>
        </div>
        <v-input :model="val" :size="size" :input-type="inputType" :placeholder="placeholder" @input="val = $event" />
        <div v-if="inputGroupAppend" class="input-group-append">
            <span class="input-group-text">{{ inputGroupAppend }}</span>
        </div>
    </div>

    <v-input v-else :model="val" :size="size" :input-type="inputType" :placeholder="placeholder" @input="val = $event" />

</template>

<style scoped lang="scss">

    .input-group {
        display: flex;
        flex-wrap: nowrap;
        position: relative;
    }

    .input-group-prepend,
    .input-group-append {
        display: flex;
        margin: 0;
        .input-group-text {
            @include font-medium(13px);
            align-items: center;
            background: $color-bg;
            border: 1px solid $color-rule;
            color: $color-text;
            display: flex;
            white-space: nowrap;
        }
    }

    .input-group-prepend {
        .input-group-text {
            margin-right: -5px;
            padding: 0 20px 0 15px;
        }
    }

    .input-group-append {
        .input-group-text {
            margin-left: -5px;
            padding: 0 15px 0 20px;
        }
    }

</style>

<script>

export default {

    props: {
        model: {
            required: false,
        },
        size: {
            type: String,
            default: 'md',
        },
        inputType: {
            type: String,
            default: 'text',
        },
        placeholder: {
            type: String,
            default: null,
        },
        inputGroupPrepend: {
            type: String,
            default: null,
        },
        inputGroupAppend: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            val: this.model,
        }
    },

    watch: {

        model(val) {
            this.val = val;
        },

        val(val) {
            this.$emit('input', val);
        },

    },

}

</script>
